import React, { useEffect, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "../../context/ThemeContext";

const InstantChatModal = ({ setShowInstantChat, showInstantChat }) => {
  const { theme } = useTheme();
  const iframeRef = useRef(null);
  
  const handleCloseModal = () => {
    setShowInstantChat(false);
  };

  // Send theme to iframe whenever it changes
  useEffect(() => {
    if (iframeRef.current && showInstantChat) {
      const sendThemeToIframe = () => {
        try {
          iframeRef.current.contentWindow?.postMessage(
            { type: 'THEME_CHANGE', theme: theme },
            '*'
          );
        } catch (error) {
          console.warn('Failed to send theme to iframe:', error);
        }
      };

      // Send theme after iframe loads
      const handleIframeLoad = () => {
        setTimeout(sendThemeToIframe, 100); // Small delay to ensure iframe is ready
      };

      // Send theme immediately if iframe is already loaded
      if (iframeRef.current.contentDocument?.readyState === 'complete') {
        sendThemeToIframe();
      } else {
        iframeRef.current.addEventListener('load', handleIframeLoad);
      }

      return () => {
        iframeRef.current?.removeEventListener('load', handleIframeLoad);
      };
    }
  }, [theme, showInstantChat]);

  return (
    <>
      {showInstantChat && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black bg-opacity-70 transition-opacity duration-300">
          <div 
            className={`relative rounded-2xl shadow-2xl p-6 border animate-fade-in z-2 mt-2 w-full max-w-[95%] px-2 sm:px-4 md:px-0 md:w-[90%] lg:w-[45%] 
            h-[calc(100dvh-13%)] md:h-[80vh] lg:h-[80vh] sm:h-[calc(100dvh-13%)] ${
              theme === 'dark' 
                ? 'bg-[#0f1115] border-gray-700' 
                : 'bg-[#FAFBFC] border-black'
            }`}
          >
            <button
              className={`absolute top-6 right-8 transition ${
                theme === 'dark' 
                  ? 'text-gray-400 hover:text-white' 
                  : 'text-gray-500 hover:text-black'
              }`}
              onClick={handleCloseModal}
              aria-label="Close modal"
            >
              <CloseIcon fontSize="small" />
            </button>
            
            <h2 className={`text-xl font-semibold mb-4 text-center ${
              theme === 'dark' ? 'text-white' : 'text-black'
            }`}>
              Got a question? Ask me!
            </h2>
            
            <iframe
              ref={iframeRef}
              src={`/instant-chat?theme=${theme}`}
              title="Instant Chat"
              className="w-full h-[95%] border-none rounded"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default InstantChatModal;
